export const CHECK_RELOGIN_TIMEOUT = 1000
export const API_AUTH = `${process.env.API_AUTH}`
export const API_HOST = `${process.env.API_HOST}`
export const IAPI_HOST = `${process.env.IAPI_HOST}`
export const REACT_APP_MAPBOX_ACCESS_TOKEN = `${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}`